import { Component, OnInit, NgZone, OnDestroy } from '@angular/core';
import { Auth, Hub } from 'aws-amplify';
import { Router } from '@angular/router';
import { ConstantsService } from "../services/constants.service";
import { CacheService } from "../services/cache.service";
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SpinnerService } from '../services/spinner.service';
import { Location } from '@angular/common';
// import { HelperService } from '../services/helper.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

  public loginForm: UntypedFormGroup;
  public resendForm: UntypedFormGroup;
  public confirmResendForm: UntypedFormGroup;
  public isProcessing = false
  public isLoading = false;
  public login = true;
  public confirmCode = false;
  fromsubscription: any;
  loginMethod: any;
  showPopup: boolean = false;
  firstTimeClick: boolean = false;
  constructor(
    private router: Router,
    private zone: NgZone,
    public constants: ConstantsService,
    private fb: UntypedFormBuilder,
    private spinner: SpinnerService,
    private cache: CacheService,
    private location: Location
    // private helperService:HelperService
    ) {


    // Used for listening to login events
    Hub.listen("auth", ({ payload: { event, data } }) => {
      if (event === "cognitoHostedUI" || event === "signedIn") {
        this.zone.run(() => this.router.navigate(['/']));
      } else {
      }
    });
  }
  initialiseForm = () => {
    this.loginForm = this.fb.group({
      email: new UntypedFormControl('', [Validators.email, Validators.required]),
      password: new UntypedFormControl('', [
        Validators.required
      ])
    })
  }
  initialiseresendForm = () => {
    this.resendForm = this.fb.group({
      email: new UntypedFormControl('', [Validators.email, Validators.required]),
    })
  }
  initialiseConfirmForm = () => {
    this.confirmResendForm = this.fb.group({
      email: new UntypedFormControl(this.resendForm.value.email),
      code: new UntypedFormControl('', [Validators.required, Validators.minLength(6),]),
      password: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern(/^(?=\D*\d)(?=[^a-z]*[a-z])(?=.*[$@#!%*?&])(?=[^A-Z]*[A-Z]).{8,}$/),
      ])
    })
  }
  ngOnInit() {
    // The section below is commented out because Publift ads need to be removed.
    // Auth.currentAuthenticatedUser()
    // .catch(()=>{
    //   if(document.getElementById("ads-script-fuse")==null){
    //     this.loadScript("https://cdn.fuseplatform.net/publift/tags/2/3701/fuse.js");
    //   }
    // })
    // this.helperService.addGlobalStyle('.publift-widget-23174194645-container,.publift-widget-23196941527-container { display: none !important}');
    this.authcall()
    this.cache.animateUI("easein");
    this.initialiseForm();
    this.initialiseresendForm();
    this.fromsubscription = this.cache.fromPricingPage;
    this.loginMethod = JSON.parse(localStorage.getItem('loginWith'));
  }

  ngOnDestroy(): void {
    // The section below is commented out because Publift ads need to be removed.
    // this.helperService.removeGlobalStyle();
  }

  // The section below is commented out because Publift ads need to be removed.
  // loadScript(src: string) {
  //   const script = document.createElement('script');
  //   script.src = src;
  //   script.id = "ads-script-fuse";
  //   script.async = true;
  //   document.head.appendChild(script);
  // }

  okayClicked() {
    this.showPopup = false;
    this.firstTimeClick = true;
  }
  onLoginClick(provider) {
    if (!this.firstTimeClick && this.loginMethod === 'email') {
      this.showPopup = true;
      return;
    }
    Auth.federatedSignIn({
      provider: provider
    });
  }
  public async authcall() {
    this.cache.getAuthUser()
      .then(data => {
        let { login } = data
        if (login) {
          this.router.navigate(['/'], { replaceUrl: true });
        }
        this.spinner.hide()
      })
      .catch(error => {
        this.spinner.hide()
      })
  }
  async onClicklogin() {
    if (!this.firstTimeClick && this.loginMethod === 'social') {
      this.showPopup = true;
      return;
    }
    this.isProcessing = true;
    let username = this.loginForm.value.email;
    let password = this.loginForm.value.password;
    try {
      const user = await Auth.signIn(username, password);
      if (this.fromsubscription === 'true') {
        this.router.navigate(['payment'], { replaceUrl: true })
      } else {
        this.router.navigate(['/'], { replaceUrl: true });
      }
    } catch (error) {
      if (error.message === "User is not confirmed.") {
        document.getElementById("resend").style.display = `block`
      }
      else {
        if (error.message === "Incorrect username or password.") {
          document.getElementById("errorAlert").innerHTML = 'Your email or password don’t match. Try again'
        }
        else {
          document.getElementById("errorAlert").innerHTML = error.message
        }
      }

      this.isProcessing = false;
    }
  }

  async onClickResend() {
    this.isLoading = true
    let username = this.loginForm.value.email
    try {
      await Auth.resendSignUp(username);
      document.getElementById("resend").innerHTML = 'Success, Please click the confirmation link send to your email'
      this.isLoading = false;
    } catch (err) {
      document.getElementById("resend").innerHTML = err.message
      this.isLoading = false;
    }
  }
  onClickForgot() {
    this.login = false;
  }
  async onClickVerify() {
    this.initialiseConfirmForm()
    this.isProcessing = true
    let username = this.resendForm.value.email;
    Auth.forgotPassword(username)
      .then(data => {
        this.confirmCode = true
        this.isProcessing = false
      })
      .catch(err => {
        this.isProcessing = false
        document.getElementById('errorAlert').innerHTML = err.message
      });
  }
  async onClickConfirmSubmit() {
    this.isProcessing = true
    let username = this.confirmResendForm.value.email;
    let code = this.confirmResendForm.value.code;
    let new_password = this.confirmResendForm.value.password;
    Auth.forgotPasswordSubmit(username, code, new_password)
      .then(data => {
        this.confirmCode = false;
        this.login = true;
        this.isProcessing = false
      })
      .catch(err => {
        document.getElementById('errorAlert').innerHTML = err.message
        this.isProcessing = false
      })
  }
  onClickSowPassowrd() {
    let inputFiled = (<HTMLInputElement>document.getElementById('input-password'))
    if (inputFiled.type === 'password') {
      inputFiled.type = 'text'
    }
    else {
      inputFiled.type = 'password'
    }
  }
  gotoPrevious() {
    this.location.back();
  }
}